import { parsePhoneNumberFromString, formatIncompletePhoneNumber } from 'libphonenumber-js';

export function formatPhoneNumber(phoneNumber: string): string {
  // Tenta parsear com libphonenumber-js primeiro
  const parsed = parsePhoneNumberFromString(phoneNumber, 'BR');
  if (parsed && parsed.isValid()) {
    const formatted = parsed.formatInternational();
    // Se formatou com espaços corretos, usar. Caso contrário, usar fallback
    if (formatted.includes(' ') && formatted.split(' ').length >= 3) {
      return formatted;
    }
    // Se não formatou direito, continuar para fallback manual
  }

  // Fallback: format manually
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');

  // Números brasileiros
  if (cleaned.startsWith('+55')) {
    const digits = cleaned.substring(3); // Remove +55

    // Celular: 11 dígitos (DDD + 9 dígitos)
    if (digits.length === 11) {
      return `+55 ${digits.substring(0, 2)} ${digits.substring(2, 7)} ${digits.substring(7)}`;
    }

    // Fixo: 10 dígitos (DDD + 8 dígitos)
    if (digits.length === 10) {
      return `+55 ${digits.substring(0, 2)} ${digits.substring(2, 6)} ${digits.substring(6)}`;
    }

    // Qualquer outro tamanho BR: pelo menos formatar com DDD
    if (digits.length >= 2) {
      return `+55 ${digits.substring(0, 2)} ${digits.substring(2)}`;
    }
  }

  // Números internacionais (não BR)
  if (cleaned.startsWith('+') && !cleaned.startsWith('+55')) {
    // Tenta identificar código do país e formatar básico
    const match = cleaned.match(/^\+(\d{1,3})(.+)$/);
    if (match) {
      const countryCode = match[1];
      const number = match[2];
      // Formatação básica: +XX XXXXXXXXX
      return `+${countryCode} ${number}`;
    }
  }

  // Se não tem +, mas tem 10-13 dígitos, pode ser internacional sem +
  if (!cleaned.startsWith('+') && cleaned.length >= 10 && cleaned.length <= 15) {
    // Assume que é BR se tiver 10-11 dígitos
    if (cleaned.length === 10 || cleaned.length === 11) {
      const digits = cleaned;
      if (digits.length === 11) {
        return `+55 ${digits.substring(0, 2)} ${digits.substring(2, 7)} ${digits.substring(7)}`;
      }
      if (digits.length === 10) {
        return `+55 ${digits.substring(0, 2)} ${digits.substring(2, 6)} ${digits.substring(6)}`;
      }
    }
  }

  // Return as-is if format is unknown
  return phoneNumber;
}

export function normalizePhoneInput(input: string): string {
  return formatIncompletePhoneNumber(input, 'BR');
}

export function validatePhone(phoneNumber: string): boolean {
  const parsed = parsePhoneNumberFromString(phoneNumber, 'BR');
  return parsed ? parsed.isValid() : false;
}